<div class="mt-1 text-xs text-red-400">
  <ng-content></ng-content>
</div>
